import { useDarkmode } from "hooks/useTheme";
import ReactApexChart from "react-apexcharts";

const chartData = [44, 55, 13];

function MembersByDemographics() {
    const {darkmode} = useDarkmode();
    
    const chartOptions = {
        labels: ['Man', 'Women', 'Children'],
        tooltip: {
            enabled: false,
        },
        dataLabels: {
            enabled: false,
        },
        plotOptions: {
            pie: {
                // customScale: 1,
                expandOnClick: false,
                donut: {
                    size: '75%',
                    labels: {
                        show: true,
                        name: {
                            fontWeight: 400,
                            fontSize: '14px',
                            color: '#A3AED0',
                        },
                        value: {
                            fontSize: '22px',
                            fontWeight: 600,
                            formatter: (v, opts) => {
                                const total = opts.globals.series.reduce((sum, x) => {return sum + x;}, 0);
                                const val = total > 0 ? parseInt(100 * v / total) : 0;            
                                return val.toString() + ' %'
                            },
                            color: darkmode ? 'white' : '#A3AED0',
                        },
                        total: {
                            show: true,
                            color: '#A3AED0',
                        }
                    }
                }
            }
        },
        legend: {
            show: true,
            horizontalAlign: 'center',
            position: 'right',
            fontWeight: 600,
            fontSize: '14px',
            height: '100%',
            formatter: (label, opts) => {
                return '<span class="dark:text-white">' + label + '</span><span class="font-normal ml-[10px] text-gray-600">' + opts.w.globals.series[opts.seriesIndex] + '</span>';
            },
            markers: {
                strokeWidth: 0,
                offsetX: -5,
                size: 5,
            },
            itemMargin: {
                horizontal: 15,
            },
        },
        states: {
            hover: { filter: 'none' },
            active: { filter: 'none' },
        },
    };
    
    const newOptions = {
        ...chartOptions,
        colors: ["#91B9A8", "#EF9C8F", "#FFC69B"],
    };

    return (
        <>
            <div className="flex-1 relative items-center rounded-[30px] p-[30px] gap-[30px] shadow-atrium shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none">
                {/* header */}
                <div className="flex">
                    <div className="flex-1">
                        <p className="text-gray-800 font-bold dark:text-white">Members by demographics</p>
                    </div>
                    <select className="bg-[transparent] text-sm text-gray-700 rounded-xl pr-4 outline-none rounded-2xl p-[8px] mr-4">
                        <option>Monthly</option>
                    </select>
                </div>

                {/* chart */}
                <div className="block h-[300px]">
                    <div className="h-full w-full">
                        <ReactApexChart
                            options={newOptions}
                            series={chartData}
                            type="donut"
                            width="100%"
                            height="100%"
                        />
                    </div>
                </div>
            </div>

        </>
    );
}

export default MembersByDemographics;
